<template>
  <span class="text-xs py-1 px-3 rounded-full bg-lime-200 text-lime-700 cursor-default">
    <MailCheck class="w-3 h-3 inline-block" />
    Referral request sent
  </span>
</template>

<script setup lang="ts">
import { MailCheck } from 'lucide-vue-next'
</script>
